import $ from "jquery";
import Quill from "quill";
import apiFetch from "@wordpress/api-fetch";
import loader from "../../../img/loading.gif";
import { v4 as uuidv4 } from "uuid";
import heic2any from "heic2any";

let BlockEmbed = Quill.import("blots/block/embed");

class ImageBlot extends BlockEmbed {
  static create(value) {
    let node = super.create();
    node.setAttribute("name", value.name);
    node.setAttribute("src", value.url);
    return node;
  }

  static value(node) {
    return {
      name: node.getAttribute("name"),
      url: node.getAttribute("src"),
    };
  }
}

ImageBlot.blotName = "image";
ImageBlot.tagName = "img";

Quill.register(ImageBlot);

$(".quill-editor").each(function (i) {
  const el = $(this);
  const id = `quilleditor-${i}`;
  const val = el.val();
  const div = $("<div/>").attr("id", id).html(val);

  el.hide();
  el.parent().append(div);

  div.wrap('<div class="team__editor-wrapper"></div>');

  const quill = new Quill(`#${id}`, {
    modules: {
      // toolbar: [["link"], ["bold"], ["italic"], ["underline"], ["image"]],
      toolbar: [["link"], ["bold"], ["italic"], ["underline"]],
    },
    placeholder: "Vložte příspěvek",
    theme: "snow",
  });

  quill.on("text-change", () => {
    el.html(quill.root.innerHTML);
  });

  // quill editor add image handler
  quill.getModule("toolbar").addHandler("image", () => {
    selectLocalImage(quill);
  });
});

function selectLocalImage(quill) {
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.click();

  // Listen upload local image and save to server
  input.onchange = () => {
    const file = input.files[0];
    
    const name = insertPlaceholderToEditor(quill);

    // file type is only image.
    if (/^image\//.test(file.type)) {
      saveToServer(quill, file, name)
    } else {
      let filename = file.name.substring(0, file.name.lastIndexOf('.'));
      let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
      
      if (ext == 'heif' || ext == 'heic') {
        var blob = file;

        heic2any({
            blob: blob,
            toType: "image/jpg",
        }).then(function (resultBlob) {
              let newFile = new File([resultBlob], filename + ".jpg", {type:"image/jpeg", lastModified: new Date().getTime()});
              saveToServer(quill, newFile, name);
            }, filename, name)
            .catch(function (x) {
                console.log(x.code);
                console.log(x.message);
            });
        
      } else {
        console.warn("You could only upload images.")
      }

    }
  };
}

async function saveToServer(quill, file, name) {
  const fd = new FormData();
  fd.append("image", file);

  try {
    // const name = insertPlaceholderToEditor(quill);

    const { url } = await apiFetch({
      path: "/xixoio/v1/post/image/upload/",
      method: "POST",
      body: fd,
    });

    updateImageUrl(quill, name, url);
  } catch (e) {
    console.error(e);
  }
}

function insertPlaceholderToEditor(quill) {
  const { index } = quill.getSelection();
  const name = uuidv4();
  quill.insertEmbed(index, "image", { name: name, url: loader });
  quill.setSelection(index + 1);
  return name;
}

function updateImageUrl(quill, name, url) {
  const contents = quill.getContents();
  const selection = quill.getSelection();
  contents.ops.forEach((item) => {
    if (item?.insert?.image?.name === name) {
      item.insert.image.url = url;
    }
  });
  quill.setContents(contents);
  quill.setSelection(selection);
}
